import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { ModalProps } from '../../Interfaces/Props';

const ModalComp: React.FC<ModalProps> = (props) => {
  return (
    <Transition appear show={props.open} as={Fragment}>
      <Dialog
        as="div"
        open={props.open}
        onClose={() => {
          return false;
        }}
         style={{display: props.isShow == false ? 'none' : ''}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        </Transition.Child>
        <div className="fixed inset-0 bg-[black]/60 w-screen overflow-y-auto" style={{ zIndex: props.zIndex ?? 999 }}>
          <div className="flex items-center justify-center min-h-full px-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`panel border-0 p-0 rounded-lg overflow-hidden w-full ${props.sizeClass} my-8 text-black dark:text-white-dark`}
              >
                <div className="flex bg-gray-100 dark:bg-gray-800 items-center justify-between px-5 py-3">
                  <p className="font-bold text-lg text-primary">{props.title}</p>
                  <div className='flex gap-x-3'>
                    {!!props.action && <div>{props.action}</div>}
                  <button
                    type="button"
                    onClick={props.onClose}
                    className="text-white-dark hover:text-dark"
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                  </div>
                </div>
                <div className="p-5">
                  {props.children}

                  <div className="flex justify-end items-center mt-8">
                    {props.closeBtnView && (
                      <button
                        type="button"
                        onClick={props.onClose}
                        className="btn btn-outline-danger"
                      >
                        Discard
                      </button>
                    )}
                    {props.onSave && (
                      <button
                        type="button"
                        onClick={props.onSave}
                        className="btn btn-primary ltr:ml-4 rtl:mr-4"
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalComp;
